import { Introduction } from './Introduction'
import { withIntroduction } from './withIntroduction'

const ConnectedIntroduction = withIntroduction(Introduction)

export { ConnectedIntroduction as Introduction }
